import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dmmp-subcontent-bullets',
  templateUrl: './subcontent-bullets.component.html'
})
export class SubcontentBulletsComponent implements OnInit {
  @Input() bullets

  constructor() { }

  ngOnInit(): void {
  }

}
